<template>
  <profile-subsection
    v-if="config"
    class="study-goal-subsection"
    :editing="isActiveSection"
    :disabled="activeSection && !isActiveSection"
    :disabled-save="!canSubmit"
    @inactive-action="$emit('set-active')"
    @active-action="updateStudyGoal"
    @cancel-action="cancel"
  >
    <template v-slot:inactive>
      <p>{{ label }} <span :class="{disabled: !studyGoal}">{{ goalDisplay }}</span> </p>
    </template>
    <template v-slot:active>
      <div class="active-study-goal">
        <label
          for="study-goal-input"
          class="study-goal-label"
        >
          {{ label }}
        </label>
        <input
          id="study-goal-input"
          v-model="goal"
          class="study-goal-input"
          type="number"
          min="1"
          max="999"
          @input="validateGoalInput"
        >
      </div>
      <p
        v-if="!validated"
        class="validation"
      >
        Please enter valid number between 1 and 999
      </p>
    </template>
  </profile-subsection>
</template>

<script>
import ProfileSubsection from '@components/profile/subsection';
import { SET_GOAL_KEY, setChecklistData } from '@/utils/checklist';

export default {
  components: {ProfileSubsection},
  props: {
    activeSection: {
      type: String,
    },
    config: {
      type: Object,
    },
  },
  data() {
    return {
      goal: 0,
      validated: false,
    };
  },
  computed: {
    canSubmit() {
      return this.goal && this.validated;
    },
    goalDisplay() {
      return this.isActiveSection ? this.goal : this.studyGoal || 10;
    },
    isActiveSection() {
      return this.activeSection === 'Study Goal';
    },
    label() {
      return `${this.config.displayName}:`;
    },
    studyGoal() {
      return this.$store.getters['session/currentUser'].userProfile?.studyGoal;
    },
  },
  mounted() {
    this.$watch('studyGoal', (newGoal, oldGoal) => {
      if (newGoal !== oldGoal) {
        this.goal = newGoal;
        this.validateGoalInput();
      }
    }, { immediate: true });
  },
  methods: {
    cancel() {
      this.$emit('clear-active');
      this.goal = this.studyGoal;
    },
    updateStudyGoal() {
      this.$emit('set-submitting', true);
      this.$store.dispatch('session/updateUserProfile', { studyGoal: this.goal }).then(() => {
        this.$analytics.events.setDailyGoal('Profile Screen');
        this.$analytics.events.setStudyGoal('Set Study Goal', { 'Number Of Questions': this.goal });
        setChecklistData(this.$store, SET_GOAL_KEY, this.$notify);
        this.$emit('set-submitting', false);
        this.$emit('clear-active');

        this.$notify({
          group: 'notifications',
          text: 'Study Goal Updated',
          type: 'success',
        });
      }).catch(e => {
        this.$emit('set-submitting', false);
        this.$emit('clear-active');

        this.$notify({
          group: 'notifications',
          text: 'Error Updating Profile',
          type: 'error',
        });
      });
    },
    validateGoalInput() {
      const numGoal = Number(this.goal);
      this.validated = !isNaN(numGoal) && numGoal >= 1 && numGoal <= 999;
    },
  },
};
</script>

<style lang="scss">
.study-goal-subsection {
  .subsection-edit {
    width: 100%;

    .active-study-goal {
      .study-goal-label,
      .study-goal-input {
        display: inline-block;
      }

      .study-goal-label {
        width: rem-calc(156);
        margin: 0 rem-calc(12) rem-calc(4) 0;
      }

      .study-goal-input {
        width: rem-calc(172);
      }

      ~ {
        .active-subsection-btn-group {
          margin-top: rem-calc(12);
        }

        .validation {
          color: #dc3416;
          font-size: rem-calc(12);
          margin: 0;
        }

        .active-subsection-btn-group, .validation {
          margin-left: rem-calc(172);

          @include breakpoint(medium) {
            margin-left: 0;
          }
        }
      }
    }
  }
}
</style>
